import React from 'react';
import createSVG from './createSVG';

const ReferenzenIcon = ({style}) => (
  <path style={style} d="M9.225,24.501 L24.5,24.501 L24.5,12.751 L9.225,12.751 L9.225,24.501 Z M8.049,18.625 L5.112,18.625 L5.112,6.875 L20.387,6.875 L20.387,11.576 M3.937,12.751 L1,12.751 L1,1 L16.275,1 L16.275,5.7" stroke="#7D7D7D" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
);

export default createSVG(ReferenzenIcon);
